import React from 'react';

export default () => {
	return <span className="icon-instagram" />;
};
